import axios from 'axios'
import { Notify } from 'vant'
import router from '../router/index.js'

// 创建axios实例
const service = axios.create({
  // baseURL: '/api', // api 的 base_url
  // baseURL: "https://apilcly.eazyun.com/api",
  baseURL:
    process.env.NODE_ENV === 'development'
      ? '/'
      : process.env.VUE_APP_BASE_API.replace(/\"/g, '') + '/', // api 的 base_url
  timeout: 1000 * 5 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    ;(config.headers['Authorization'] = sessionStorage.getItem('token')),
      (config.headers['Content-Type'] = 'application/json')
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const code = response.status
    if (code < 200 || code > 300) {
      Notify({ type: 'danger', message: response.message })
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    let code = 0
    try {
      code = error.response.data.status
      if (code == 401 && process.env.NODE_ENV == 'development') {
        Notify({ type: 'danger', message: '身份过期，请重新登录' })
        return router.push('/login')
      }
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Notify({ type: 'danger', message: '网络请求超时' })
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js